import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
// img
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { useGetFeedbackStepDetailQuery, useSubmitFeedbackStepMutation } from "store/services/clients/assessmentTreatmentPlan";
import { Formik } from "formik";
import AttachDocumentsReports from "components/shared/ReportComponents/AttachDocumentsReports";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CLIENT_REPORT_TYPES, REPORT_IDS, REPORT_QUESTIONS } from "config/constants";
import LoadingButton from "components/shared/LoadingButton";
import { object } from "yup";
import { TREATMENT_PLAN } from "config/paths";
import RenderQuestion, { RenderQuestionById } from "components/shared/ReportComponents/Questions/Index";
import { reportQuestionsValidationSchema } from "utils/validation/validationHelpers";
import { formatReportFeedback, greetingFieldPlaceholders, reportInitialValues } from "helpers/assessment";
import ClientDetails from "components/shared/ReportComponents/ClientDetails";
import KhanReportLogo from "components/shared/ReportComponents/KhanReortLogo";
import ReportHeader from "components/shared/ReportComponents/ReportHeader/Index";
import ReportError from "../../components/ReportError";
// import { useGetFormalAssessmentsQuery } from "store/services/utility";

const ClientTreatmentPlanReport = () => {
  const navigate = useNavigate();

  const { assessmentId, clientId, clientType } = useParams();

  const [reportHeading, setReportHeading] = useState(
    CLIENT_REPORT_TYPES[REPORT_IDS.TREATMENT_PLAN_REPORT].title
  );

  // const {data: formalAssessments} = useGetFormalAssessmentsQuery();
  const [submitStep, { isLoading: submittingStep }] = useSubmitFeedbackStepMutation();
  const { data, isLoading, isFetching, isError, refetch } = useGetFeedbackStepDetailQuery({ assessmentId, clientId, clientType });
  const assessmentGoals = data?.assesmentData?.reportGoals;
  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist, discipline_id: data?.clientPendingCaseload?.clientCaseloadTherapist?.discipline_id }

  useEffect(() => {
    refetch();
  }, [refetch])

  const initialValues = useMemo(() => {
    if (!data) return {};
    let answers = data?.assesmentData?.reportAnswers;
    let values = {
      documents: data?.assesmentData?.reportDocuments,
      resources: data?.assesmentData?.reportResources,
    };

    values = reportInitialValues(values, reportQuestions, answers);

    return values;
  }, [data]);

  const validationSchema = useMemo(() => {
    if (!reportQuestions) return object();

    return reportQuestionsValidationSchema(reportQuestions);
  }, [reportQuestions])

  const handleSubmitStep = async (values) => {
    try {
      let payload = formatReportFeedback(reportHeading, reportQuestions, values);

      let response = await submitStep({
        assessmentAssignedId,
        data: payload,
        clientType
      });

      if (!response?.error) {
        navigate(generatePath(TREATMENT_PLAN, {
          assessmentId,
          clientId: clientId,
          clientType
        }))
      }

    } catch (err) {
      console.error("Error submitting step three", err);
    }
  };

  return (
    <>
      <section className="ReportSec py-3 position-relative">
        <Container fluid>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmitStep}
            validationSchema={validationSchema}
            enableReinitialize
          >
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col lg="12" className="my-2">
                    <div className="cardCstm p-lg-5 rounded-2 bg-white shadow">
                      {isLoading ? (
                        <LoadingIndicator />
                      ) : isError ? (
                        <ErrorComponent />
                      ) : (
                        <>
                          {isFetching && <LoadingOverlay />}
                          <ReportHeader
                            initialHeading={data?.assesment?.report_heading || reportHeading}
                            therapistDetails={therapistDetails}
                            setHeading={setReportHeading}
                          />
                          <div className="formBody pt-3">
                            <div
                              className=""
                              style={{ borderBottom: "2px dashed #6c6c6c" }}
                            >
                              <div className="py-3">
                                <div
                                  className="cardCstm rounded-2 px-3"
                                  style={{ background: "#F9F9F9" }}
                                >
                                  <ClientDetails
                                    data={data}
                                    showAssessmentDate={false}
                                  />
                                </div>
                              </div>

                              {reportQuestions?.length > 0 &&
                                reportQuestions?.map((question, index) => {
                                  if (
                                    [
                                      REPORT_QUESTIONS.greeting,
                                      REPORT_QUESTIONS.summary,
                                      REPORT_QUESTIONS.recommendation,
                                    ].includes(question.id)
                                  ) {
                                    return null;
                                  }

                                  return (
                                    <div className="py-3">
                                      <RenderQuestion
                                        key={index}
                                        question={question}
                                        fieldName={question.id}
                                      />
                                    </div>
                                  );
                                }
                                )}
                              {/* Removed by the client line no - 44*/}

                              {/* <div className="py-3">
                                <h6 className="m-0 fw-sbold themeBlue pb-1">
                                  Treatment plan
                                </h6>
                                <div className="d-flex align-items-center gap-10 mt-3">
                                  <h6 className="m-0 fw-sbold themeBlue pb-1">
                                    Discipline
                                  </h6>
                                  <input
                                    type="text"
                                    value={
                                      therapistDetails?.caseDiscipline
                                        ?.name
                                    }
                                    className="form-control text-dark fw-bold text-center"
                                    style={{
                                      background: "#e9e9e9",
                                      maxWidth: 220,
                                    }}
                                    readOnly
                                  />
                                </div>

                              </div> */}
                              {assessmentGoals?.length > 0 && (
                                <div className="py-3">
                                  <div className="py-3">
                                    <div
                                      className="cardCstm rounded-3 p-3"
                                      style={{ background: "#FBFBE6" }}
                                    >
                                      {assessmentGoals?.map((goal, index) => (
                                        <div className="my-2">
                                          <div className="top d-flex align-items-start">
                                            <h5 className="m-0 fw-bold themeBlue">
                                              {index + 1}.
                                            </h5>
                                            <div className="px-3">
                                              <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                                Area
                                              </h5>
                                              <p className="m-0 themeBlue pt-1">
                                                {goal?.assesmentGoalDisciplineArea?.name}
                                              </p>
                                            </div>
                                            <div className="px-3">
                                              <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                                Goal
                                              </h5>
                                              <p className="m-0 themeBlue pt-1">
                                                {goal?.assesmentGoalDetail?.title}
                                              </p>
                                            </div>
                                            <div className="px-3">
                                              <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                                Context
                                              </h5>
                                              <p className="m-0 themeBlue pt-1">
                                                {goal?.assesmentGoalContext?.context}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="bottom pt-4 w-lg-50">
                                            <h6 className="m-0 fw-bold themeBlue mb-3">
                                              Goal Details
                                            </h6>
                                            <div
                                              className="px-lg-4 p-3 rounded-3"
                                              style={{ background: "#F2F3DA" }}
                                            >
                                              <p className="m-0 themeBlue">
                                                {goal?.goal_description}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="bottom pt-4 w-lg-50">
                                            <h5 className="m-0 fw-bold themeBlue mb-3">
                                              Goal Review
                                            </h5>
                                            <div
                                              className="px-lg-4 p-3 rounded-3"
                                              style={{ background: "#F2F3DA" }}
                                            >
                                              <p className="m-0 themeBlue">
                                                {goal?.goal_notes}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                      }
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={REPORT_QUESTIONS.summary}
                                  reportQuestions={reportQuestions}
                                />
                              </div>
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={REPORT_QUESTIONS.recommendation}
                                  reportQuestions={reportQuestions}
                                />
                              </div>
                              <div className="py-3">
                                <AttachDocumentsReports
                                  acl={"private"}
                                  name="documents"
                                  allowedTypes={["pdf", "doc", "docx", "jpg", "xlsx", "png"]}
                                />
                              </div>
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={REPORT_QUESTIONS.greeting}
                                  reportQuestions={reportQuestions}
                                  showQuestion={false}
                                  fieldData={greetingFieldPlaceholders({ ...therapistDetails, clientDetail: { lastname: data?.lastname, firstname: data?.firstname } })}
                                />
                              </div>
                            </div>
                            <div className="py-3">
                              <img
                                src={
                                  therapistDetails?.caseTherapist
                                    ?.therapist_detail?.signature_img
                                }
                                style={{ height: 70 }}
                                alt=""
                                className="img-fluid object-fit-contain"
                              />
                              <p className="m-0 fw-sbold" style={{ whiteSpace: "pre-wrap" }}>
                                {therapistDetails?.caseTherapist?.therapist_detail?.email_signature}
                              </p>
                            </div>
                            <div className="py-3">
                              <KhanReportLogo />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <ReportError />
                    <LoadingButton
                      type="submit"
                      className="d-flex align-items-center justify-content-center commonBtn"
                      isLoading={submittingStep}
                    >
                      Save & Next
                    </LoadingButton>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Container>
      </section>
    </>
  );
};

export default ClientTreatmentPlanReport;
